import { createFileRoute } from "@tanstack/react-router";
import { citiesQueryOptions } from "../../../features/activities/hooks/use-cities";
import { CitiesPage } from "../../../features/home/pages/cities-page";

// Every city as one grid. Prefetched in the loader so the cards (and their
// links to each city hub) are in the server-rendered HTML for crawlers.
export const Route = createFileRoute("/$lang/_layout/place/")({
  loader: ({ context, params }) => context.queryClient.ensureQueryData(citiesQueryOptions(params.lang)),
  component: CitiesPage,
});
